var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.location.name != ""
    ? _c("div", { staticClass: "address" }, [
        _c("div", { staticClass: "title" }, [_vm._v("Address")]),
        _c("p", [
          _vm._v(" " + _vm._s(_vm.location.address)),
          _c("br"),
          _vm._v(" " + _vm._s(_vm.location.zipAndCity)),
          _c("br"),
          _vm.location.openingHours != ""
            ? _c("i", { staticClass: "fa fa-clock-o" })
            : _vm._e(),
          _vm._v(" " + _vm._s(_vm.location.openingHours) + " "),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }